/**
 * HustlePointsPromoBanner — drop-in banner for sales pages.
 * "Earn 10% back in Hustle Points on every $ spent."
 * Usage: <HustlePointsPromoBanner variant="dark" />
 */
import { Link } from "react-router-dom";
import { Coins, ArrowRight } from "lucide-react";

export default function HustlePointsPromoBanner({ variant = "amber" }) {
  const isDark = variant === "dark";
  return (
    <Link
      to="/points"
      data-testid="hustle-points-promo-banner"
      className={
        `block rounded-2xl px-6 py-5 transition ${
          isDark
            ? "bg-gradient-to-r from-stone-900 via-stone-800 to-amber-950 text-amber-300 hover:from-stone-950 hover:to-amber-900 border border-amber-900"
            : "bg-gradient-to-r from-amber-500 via-orange-500 to-rose-500 text-slate-950 hover:from-amber-400 hover:to-rose-400"
        }`
      }
    >
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <Coins size={26}/>
          <div>
            <div className="font-black text-lg">
              Get 10% back in Hustle Points.
            </div>
            <div className={`text-sm ${isDark ? "text-amber-200/80" : "opacity-80"}`}>
              Top up $100, get 110 pts. Redeem anywhere across the ecosystem — 10 pts = $1.
            </div>
          </div>
        </div>
        <div className="inline-flex items-center gap-1 font-black text-sm whitespace-nowrap">
          Start earning <ArrowRight size={14}/>
        </div>
      </div>
    </Link>
  );
}
